const API_ENDPOINT = '/api/2025-04/graphql.json';
const STOREFRONT_ACCESS_TOKEN = '7db84991cf9cb404049fd6666e719a97';

// Storefront API 호출 공통 함수
async function fetchStorefrontApi(query, variables) {
  const response = await fetch(API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
    },
    body: JSON.stringify({ query, variables })
  });
  const result = await response.json();
  return result.data || {};
}

// 카트 ID 가져오기
async function getCartId() {
  const response = await fetch('/cart.js', { cache: 'no-store' });
  const cart = await response.json();
  return cart.token ? `gid://shopify/Cart/${cart.token}` : null;
}

// customerAccessToken 생성
async function loginAndGetCustomerAccessToken(email, password) {
  const query = `
    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
      customerAccessTokenCreate(input: $input) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
  `;
  const variables = { input: { email, password } };
  const data = await fetchStorefrontApi(query, variables);

  const customerAccessToken = data?.customerAccessTokenCreate?.customerAccessToken?.accessToken || null;
  if (customerAccessToken) {
    localStorage.setItem('customerToken', customerAccessToken);
  }
  return customerAccessToken;
}

// customerAccessToken 생성 (multipass)
async function loginAndGetCustomerAccessTokenWithMultipass(multipassToken) {
  const query = `
    mutation customerAccessTokenCreateWithMultipass($multipassToken: String!) {
      customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
  `;
  const variables = { multipassToken };
  const data = await fetchStorefrontApi(query, variables);

  const customerAccessToken = data?.customerAccessTokenCreateWithMultipass?.customerAccessToken?.accessToken;
  localStorage.setItem('customerToken', customerAccessToken);
  return customerAccessToken;
}

// BuyerIdentity 업데이트
async function updateCartBuyerIdentity(cartId, customerAccessToken) {
  const query = `
      mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
        cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
          cart {
            id
            buyerIdentity {
              email
              customer {
                id
                email
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
  `;
  const variables = { cartId, buyerIdentity: { customerAccessToken } };
  const data = await fetchStorefrontApi(query, variables);
  
  if (data?.cartBuyerIdentityUpdate?.cart) {
    console.log('BuyerIdentity updated:', data.cartBuyerIdentityUpdate.cart);
    return data.cartBuyerIdentityUpdate.cart.buyerIdentity;
  } else {
    console.error('Errors:', data?.cartBuyerIdentityUpdate?.userErrors);
    return null;
  }
}

// BuyerIdentity 확인
async function checkCartBuyerIdentity(cartId) {
  const query = `
    query($cartId: ID!) {
      cart(id: $cartId) {
        id
        buyerIdentity {
          email
          customer {
            id
            email
          }
        }
      }
    }
  `;
  const variables = { cartId };
  const data = await fetchStorefrontApi(query, variables);
  
  return data?.cart?.buyerIdentity || null;
}

async function handleLoginAndUpdateBuyerIdentity(customerAccessToken) {
  const cartId = await getCartId();
  localStorage.setItem('cartId', cartId);
  await updateCartBuyerIdentity(cartId, customerAccessToken);
  
  // const verifiedBuyerIdentity = await checkCartBuyerIdentity(cartId);
  // console.log('Verified BuyerIdentity:', verifiedBuyerIdentity);
}

function logout() {
  localStorage.removeItem('customerToken');
  localStorage.removeItem('customerEmail');
  localStorage.removeItem('cartId');
  localStorage.removeItem('shopifyId');
  sessionStorage.removeItem('useCouponCode');
  window.location.href = '/account/logout';
}